import Color from 'color';

Color.prototype.lightenBy = function lightenBy(ratio) {
  const l = this.lightness();
  return this.lightness(l + (100 - l) * ratio);
};

Color.prototype.darkenBy = function darkenBy(ratio) {
  const l = this.lightness();
  return this.lightness(l - l * ratio);
};

export const lighten = (c, pct) => Color(c).lightenBy(pct).rgb().toString();
export const darken = (c, pct) => Color(c).darkenBy(pct).rgb().toString();

export default Color;
